<template>
    <main class="main" id="main">

        <div class="top_line">
            <div class="container">
                <h1>Личный кабинет - Заработать бонусы</h1>
            </div>
        </div>
        <!----------Section LK------------->

        <section class="section s-lk">

            <div class="container">

                <div class="lk_box">
                    <navigate></navigate>

                    <div class="account_box">

                        <h1>Бонусная программа - возврат реальными деньгами</h1>
                        <div class="programm_box">
                            <p>Да! У нас реальный cash-back, а не баллы или бонусы!
                                Забудьте о непонятных баллах, бонусах и их пересчёте -
                                всё это в прошлом. Сейчас всё чётко и понятно: реальный
                                cash-back в рублях!</p>
                            <div class="bonus_info">
                                <h2>1 бонусный рубль = 1 рубль и точка!</h2>
                                <a href="#">Подробнее о бонусной системе</a>
                            </div>
                        </div>

                        <div class="table_title">
                            <h1>История привлечений</h1>
                            <button type="button" @click="referralsToggle = !referralsToggle" :class="referralsToggle?'active choice_toggle':'choice_toggle'" id="referals_toggle"></button>
                        </div>
                        <div :class="referralsToggle?'active table_box':'table_box'" v-if="users" id="referal_table">
                            <table class="bonus_table">
                                <tr class="empty_row ">

                                </tr>

                                <tr class="bonus_row active">
                                    <th>Дата</th>
                                    <th>Время</th>
                                    <th>Пользователь</th>
                                </tr>

                                <tr class="bonus_row" v-for="(data, index) in users" :key="index">
                                    <td>{{data.date}}</td>
                                    <td>{{data.time}}</td>
                                    <td>{{data.source}}</td>
                                </tr>

                            </table>
                        </div>
                        <div class="referal_history empty" v-else>
                            <h2>Вы еще никого не пригласили</h2>
                        </div>

                        <h1>Сводная статистика</h1>
                        <div class="statistics_box">

                            <div class="statistic_row">
                                <span>Переходов по вашей ссылке</span>
                                <span>{{count}}</span>
                            </div>

                            <div class="statistic_row">
                                <span>Завершенных заказов</span>
                                <span>{{orders}}</span>
                            </div>

                            <div class="statistic_row">
                                <span>Заработано рублей</span>
                                <span>{{sum}} руб</span>
                            </div>

                        </div>

                        <div class="table_title">
                            <h1>Получено и потрачено</h1>
                            <button type="button" @click="bonusToggle = !bonusToggle" :class="bonusToggle?'active choice_toggle':'choice_toggle'" id="bonus_toggle"></button>
                        </div>

                        <div :class="bonusToggle?'active table_box':'table_box'" id="bonus_table" v-if="log">
                            <table class="bonus_table">
                                <tr class="empty_row ">

                                </tr>

                                <tr class="bonus_row active">
                                    <th>Дата</th>
                                    <th>Время</th>
                                    <th>Источник начисления</th>
                                    <th>Кол-во бонусов</th>
                                </tr>

                                <tr class="bonus_row" v-for="(data, index) in log" :key="index">
                                    <td>{{data.date}}</td>
                                    <td>{{data.time}}</td>
                                    <td>{{data.source}}</td>
                                    <td>{{data.sum}}</td>
                                </tr>

                            </table>
                        </div>

                        <div class="referal_history empty" v-else>
                            <h2>В истории пока нет записей</h2>
                        </div>

                        <h1>Зарабатывай с нами!</h1>

                        <div class="referal_types">
                            <div class="type_box">
                                <div class="type_description">
                                    <h2>По ссылке</h2>
                                    <p>Все очень просто – приводите новых клиентов
                                        на <a href="#">хочу-поесть.рф</a> и получайте 50% нашей
                                        прибыли от каждого заказа.Заработать можно
                                        разными способами, выбирай один или
                                        воспользуйся всеми.Зарегистрируйся на сайте
                                        и генерируй свою реферальную ссылку, которую
                                        можно отправить друзьям, поделиться в соцсетях
                                        или опубликовать на сайте или в блоге. Ты
                                        можешь сделать реферальную ссылку на любую
                                        страницу сайта <a href="#">хочу-поесть.рф</a></p>
                                </div>

                                <div class="type_share">
                                    <div class="copy_box">
                                        <div class="copy_info">
                                            <span type="text" class="earn_input">https://хочу-поесть.рф/promocode/admin</span>
                                        </div>
                                        <button class="copy"><img src="https://xn----jtbzbeohcqv6d.xn--p1ai/static/img/referals/copy.svg" alt=""></button>
                                    </div>
                                </div>

                            </div>

                        </div>

                    </div>

                </div>
            </div>
        </section>
    </main>
</template>

<script>
import navigate from '@/pages/lk/client/navigate'
import axios from '@/router/http'
export default {
  name: 'profile',
  props: ['city', 'auth', 'basket', 'geo', 'user'],
  data () {
    return {
      pay: 'bonus',
      referralToggle: false,
      referralsToggle: false,
      bonusToggle: false,
      collapse: false,
      count: 0,
      orders: 0,
      sum: 0,
      users: [],
      log: []
    }
  },
  created () {
    axios.get('https://lk.when-hungry.com/mobile/get-bonuses-log?uid=' + this.auth.uid).then(response => {
      this.count = response.data.count
      this.orders = response.data.orders
      this.sum = response.data.sum
      this.log = response.data.log
      this.users = response.data.users
    })
    $('#bonus_toggle').on('click', function () {
      $('#bonus_toggle').toggleClass('active')
      $('#bonus_table').toggleClass('active')
    })
  },
  components: {navigate}
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/lk/client/bonus.vue